import Decimal from 'decimal.js';

Decimal.set({ precision: 28, rounding: Decimal.ROUND_HALF_EVEN });
export { Decimal };
export const D = (value: Decimal.Value) => new Decimal(value);
export const money = (value: Decimal.Value) => D(value).toDecimalPlaces(2);
export const rate = (percent: Decimal.Value) => D(percent).div(100);
export const sum = (values: readonly Decimal[]) => values.reduce((a, b) => a.plus(b), D(0));
